import React, {useState} from 'react';

import Product from '../../types/product';
import Common from './Common';
import { productService } from '../../services/product';

function NewProductGroup(props: any){

    const [selectedParentProduct, setSelectedParentProduct] = useState<Product | null>(null);
    const [selectedChildrenProducts, setSelectedChildrenProducts] = useState<Product[] | null>(null);

    const createProductGroup = (orderChanged: boolean, childrenProductsSelectionChanged: boolean, ignoreParentVariantsChecked: boolean) => {
        if( selectedParentProduct && selectedChildrenProducts ) {
            const reqBody = {
                parent_handle: selectedParentProduct.handle,
                parent_id: selectedParentProduct.id,
                children: selectedChildrenProducts.map((item) => {
                    return {id: item.id, handle: item.handle};
                }),
                order_changed: orderChanged,
                ignore_parent: ignoreParentVariantsChecked,
                children_selection_changed: childrenProductsSelectionChanged
            }

            // create request
            productService.createGroup(reqBody).then(data => {
                if( data )
                    props.history.push('/');
            });
        }
    }

    return (
        <Common
            selectedParentProduct={selectedParentProduct}
            selectedChildrenProducts={selectedChildrenProducts}
            handleParentProductChange={setSelectedParentProduct}
            handleChildrenProductsChange={setSelectedChildrenProducts}
            ignoreParent={false}
            onSave={createProductGroup}
        />
    );
}

export default NewProductGroup;